// Generated by GitHub Copilot

/** A pending authenticator app from `POST /auth/account/me/mfa/authenticator-app`, to scan or type in before confirming it with a first code. */
export default class AuthenticatorAppEnrollment {
    /** Base32 secret, for an authenticator app that cannot scan the QR code. */
    secret: string = "";
    /** `otpauth://` URI to render as a QR code. */
    otpauth_uri: string = "";

    /** The secret in groups of four, which is easier to type over. */
    get groupedSecret(): string {
        return this.secret.match(/.{1,4}/g)?.join(" ") ?? "";
    }
}
